import {
    setLocalStorage,
    getLocalStorage,
    isLocalStorageAvailable,
} from "./localStorage";
import { RECENT_BOOKMAKERS_MAP } from "../bookmakersList/bookmakersList.constants";

const updateUserAccountsInfoStorage = (bookmaker, isLoggedIn) => {
    if (isLocalStorageAvailable()) {
        const userAccountsInfo = getLocalStorage("userAccountsInfo") || {};
        const recentBookmakers = getLocalStorage("recentBookmakers") || {};
        const { apiName, feed, isExternalLogout, userInfo } = bookmaker;
        const balance = userInfo && userInfo.balance;
        const recentBookmaker = bookmaker.name === "skybet" ? RECENT_BOOKMAKERS_MAP.skybet : RECENT_BOOKMAKERS_MAP[bookmaker.apiName];
        recentBookmakers[recentBookmaker] = true;

        if (!userAccountsInfo[feed]) {
            userAccountsInfo[feed] = {};
        }

        userAccountsInfo[feed] = {
            balance: isNaN(balance) ? userAccountsInfo[feed].balance : balance,
            isLoggedIn,
            apiName,
            feed,
            isExternalLogout,
        };

        setLocalStorage("userAccountsInfo", userAccountsInfo);
        setLocalStorage("recentBookmakers", recentBookmakers);
    }
};

export default updateUserAccountsInfoStorage;



// WEBPACK FOOTER //
// /src/js/common/utils/userAccountsInfo.js